// vue-loader at least v13.0.0+
module.exports = file => require('@/components/' + file + '.vue').default 


// WEBPACK FOOTER //
// ./src/router/_import_development.js